<template>
  <ResetPage :context="context" />
</template>

<script>
import ResetPage from './components/ResetPage.vue'

export default {
  name: '',
  data() {
    return {
      email: {
        type: 'email', // 关联逻辑，不可随意更改
        langObj: {
          title: this.$t('login.resetPassword.resetPassword'),
          titleDescription: this.$t(
            'login.resetPassword.sendEmailRegisteredCode'
          ),
          accountTitle: this.$t('login.resetPassword.labelRegisteredEmail'),
          accountLabel: this.$t('login.resetPassword.enterEmail'),
          accountRequireLabel: this.$t('login.resetPassword.validEmail'),
        },
      },
      phone: {
        type: 'phone', // 关联逻辑，不可随意更改
        langObj: {
          title: this.$t('login.resetPassword.resetPassword'),
          titleDescription: this.$t(
            'login.resetPassword.sendPhoneRegisteredCode'
          ),
          accountTitle: this.$t('login.resetPassword.labelRegisteredPhone'),
          accountLabel: this.$t('login.resetPassword.enterMobilePhone'),
          accountRequireLabel: this.$t('login.resetPassword.validPhone'),
        },
      },
    }
  },

  components: { ResetPage },

  computed: {
    context() {
      return this[this.type]
    },
    type() {
      // email/phone
      return this.$route.params.type || 'phone'
    },
  },

  beforeMount() {},

  mounted() {},

  methods: {},
}
</script>
<style lang="scss" scoped></style>
